import {API_URLS} from '@/const';
import {http} from '@/helper';
import {timeUtil} from '@/helper/time';

export const contractApi = {
  contractIntroduction(query) {
    return http.get(API_URLS.CONTRACT_INTRODUCTION, {query});
  },
  getInsuranceMap(query) {
    return http.get(API_URLS.INSURANCE_MAP, {query});
  },
  getFundList(query) {
    return http.get(API_URLS.INSURANCE_LIST, {query});
  },
  getFundListV2(query) {
    return http.get(API_URLS.INSURANCE_LIST_V2, {query});
  },
  getFundingRateList(query) {
    return http.get(API_URLS.FUNDING_RATE_LIST, {
      query,
      formatter({rows, total}) {
        const items = rows.map((item) => ({...item, ...{fundingTime: item.intervalSeconds ? item.intervalSeconds / 3600 : 8}}));
        return {rows: items, total};
      },
    });
  },
  getCurrentFundingRate(query) {
    return http.get(API_URLS.CURRENT_FUNDING_RATE_LIST, {
      query,
      formatter({rows, total}) {
        const items = rows.map((item) => {
          return {
            ...item,
            fundingTime: item.fundingInterval ? item.fundingInterval / 3600 : 8,
            nexFundingSettleTime: item.nextfundingTime ? timeUtil.formatDateTime(item.nextfundingTime) : '-',
          };
        });
        return {rows: items, total};
      },
    });
  },
  getContractTransferCurrencies(query) {
    return http.get(API_URLS.CONTRACT_TRANSFER_CURRENCIES, {query});
  },
  postContractConvert(params) {
    return http.post(API_URLS.CONTRACT_CONVERT, {params});
  },
  getFoundHistoryData(symbol) {
    return http.get(API_URLS.FUNDING_RATE_DATE_ALL, {query: {symbol}});
  },
  getExpiredBonus(query) {
    return http.get(API_URLS.EXPIRED_BONUS, {query});
  },
  publicGetRankingBoardData(query) {
    return http.get(API_URLS.CONTRACT_PUBLIC_RANKING_BOARD, {query});
  },
  publicGetDailyLeaderBoardData(query) {
    return http.get(API_URLS.CONTRACT_PUBLIC_DAILY_BOARD, {query});
  },
  getRankingBoardData(query) {
    return http.get(API_URLS.CONTRACT_RANKING_BOARD, {query});
  },
  getDailyLeaderBoardData(query) {
    return http.get(API_URLS.CONTRACT_DAILY_BOARD, {query});
  },
  getIndexSources() {
    return http.get(API_URLS.INDEX_SOURCES, {});
  },
  contractBoardUnfollow(userCode) {
    return http.post(API_URLS.CONTRACT_BOARD_FOLLOW, {params: {userCode, status: 0}});
  },
  contractBoardFollow(userCode) {
    return http.post(API_URLS.CONTRACT_BOARD_FOLLOW, {params: {userCode, status: 1}});
  },
  getContractBoardFollowList(query) {
    return http.get(API_URLS.CONTRACT_BOARD_FOLLOW_LIST, {query});
  },
  getContractBoardUserInfo(userCode) {
    return http.get(API_URLS.CONTRACT_BOARD_USER_SHARE_INFO, {query: {userCode}});
  },
  publicContractBoardUserInfo(userCode) {
    return http.get(API_URLS.CONTRACT_BOARD_PUBLIC_USER_SHARE_INFO, {query: {userCode}});
  },
  getMyContractBoardShareSetting() {
    return http.get(API_URLS.CONTRACT_BOARD_USER_SHARE_SETTING, {query: {}});
  },
  updateContractBoardShareSetting({openRank, sharePosition}) {
    return http.post(API_URLS.CONTRACT_BOARD_USER_SHARE_SETTING_UPDATE, {params: {openRank, sharePosition}});
  },
  getContractPostRanking(query) {
    return http.get(API_URLS.CONTRACT_BOARD_HISTORY, {query});
  },
  getUserDailyRankData(query) {
    return http.get(API_URLS.CONTRACT_BOARD_USER_DAILY_DATA, {query});
  },
  getUserPeriodicRankData(query) {
    return http.get(API_URLS.CONTRACT_BOARD_USER_PERIODIC_DATA, {query});
  },
  getUserPositionList(query) {
    return http.get(API_URLS.CONTRACT_BOARD_USER_POSITION_LIST, {query});
  },
  getPublicUserFollowingList(query) {
    return http.get(API_URLS.CONTRACT_BOARD_PUBLIC_FOLLOWING_LIST, {query});
  },
  getPublicUserFollowerList(query) {
    return http.get(API_URLS.CONTRACT_BOARD_PUBLIC_FOLLOWER_LIST, {query});
  },
  getUserFollowingList(query) {
    return http.get(API_URLS.CONTRACT_BOARD_FOLLOWING_LIST, {query});
  },
  getUserFollowerList(query) {
    return http.get(API_URLS.CONTRACT_BOARD_FOLLOWER_LIST, {query});
  },
};
